import { render, staticRenderFns } from "./ManagerEmails.vue?vue&type=template&id=48ba667c&scoped=true"
import script from "./ManagerEmails.vue?vue&type=script&lang=js"
export * from "./ManagerEmails.vue?vue&type=script&lang=js"
import style0 from "./ManagerEmails.vue?vue&type=style&index=0&id=48ba667c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ba667c",
  null
  
)

export default component.exports